import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Exposes SPA navigation for non-React code (e.g. push toasts, SW notification click).
 */
const RouterNavigateBridge = () => {
  const history = useHistory();

  useEffect(() => {
    const navigate = (to) => {
      if (!to) return;
      try {
        if (/^https?:\/\//i.test(to)) {
          const url = new URL(to, window.location.origin);
          if (url.origin === window.location.origin) {
            history.push(`${url.pathname}${url.search}${url.hash}`);
            return;
          }
          window.location.assign(to);
          return;
        }
        history.push(to);
      } catch (_) {
        window.location.assign(to);
      }
    };

    Object.defineProperty(window, '__routerNavigate', {
      value: navigate,
      writable: false,
      configurable: true,
      enumerable: false,
    });

    return () => {
      delete window.__routerNavigate;
    };
  }, [history]);

  return null;
};

export default RouterNavigateBridge;
